import { Injectable } from '@angular/core';
import { map, Observable, from, catchError, throwError, mergeMap } from 'rxjs';
import { CommonHttpModule } from '../../providers/commonHttpModule';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private http: CommonHttpModule) {}

  getPresignedUrl(data: any): Observable<any> {
    return this.http.post('file_upload', data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  uploadImageToS3(presignedUrl: string, file: File): Observable<any> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', file.type);
    const requestOptions: RequestInit = {
      method: 'PUT',
      headers: myHeaders,
      body: file,
      redirect: 'follow' as RequestRedirect,
    };
    const uploadFile = fetch(presignedUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Upload failed: ' + response.statusText);
        }
        if (response.status === 200) {
          return response.text();
        }
        return null;
      })
      .then((text) => {
        if (text) {
          try {
            return JSON.parse(text);
          } catch (error) {
            console.error('Failed to parse JSON from response:', error);
            return null;
          }
        }
        return null;
      })
      .catch((error) => {
        throw error;
      });

    return from(uploadFile);
  }

  fileUploadToDb(data: any): Observable<any> {
    return this.http.post('file_upload_save', data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  fileDataFromDb(data: any): Observable<any> {
    return this.http.post('list_of_uploaded_files', data).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  deleteFileFromDb(fileId: any): Observable<any> {
    return this.http.delete(`file_delete/${fileId}`, {}).pipe(
      map((response) => {
        return response;
      }),
    );
  }

  downloadReport(data: any, disbursement_id: string) {
    return (
      this.http.postForReport('report_generation', data, {
        responseType: 'blob',
      } as any) as Observable<Blob>
    ).pipe(
      map((response: Blob) => {
        const fileURL = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `${disbursement_id}_${data.report_type}.pdf`;
        link.click();
        URL.revokeObjectURL(fileURL);
        return response;
      }),
      catchError((error: any) => {
        if (error?.error instanceof Blob) {
          return from(error.error.text() as Promise<string>).pipe(
            mergeMap((errorText: string) => {
              let errMsg = 'Something went wrong. Please try again later.';
              try {
                const errorJson = JSON.parse(errorText);
                errMsg = errorJson?.error || errorJson?.details || errMsg;
              } catch (e) {
                console.error('Error parsing blob response:', e);
              }
              return throwError(() => new Error(errMsg));
            }),
          );
        }
        const errMsg =
          error?.error?.error ||
          error?.error?.details ||
          error?.message ||
          'Something went wrong. Please try again later.';
        return throwError(() => new Error(errMsg));
      }),
    );
  }

  viewReport(data: any, disbursement_id: string) {
    return (
      this.http.postForReport('report_generation', data, {
        responseType: 'blob',
      } as any) as Observable<Blob>
    ).pipe(
      catchError((error: any) => {
        if (error?.error instanceof Blob) {
          return from(error.error.text() as Promise<string>).pipe(
            mergeMap((errorText: string) => {
              let errMsg = 'Something went wrong. Please try again later.';

              try {
                const errorJson = JSON.parse(errorText);
                errMsg = errorJson?.error || errorJson?.details || errMsg;
              } catch (e) {
                console.error('Error parsing blob response:', e);
              }

              return throwError(() => new Error(errMsg));
            }),
          );
        }

        const errMsg =
          error?.error?.error ||
          error?.error?.details ||
          error?.message ||
          'Something went wrong. Please try again later.';

        return throwError(() => new Error(errMsg));
      }),
    );
  }

  fileDataForCommunicationHistory(data: any): Observable<any> {
    return this.http.post('list_of_uploaded_files_comm_hist', data).pipe(
      map((response) => {
        return response;
      }),
    );
  }
uploadTimelineDocument(
  disbursementId: string,
  stepTitle: string,
  fileName: string,
  file: File
): Observable<any> {

  const formData = new FormData();

  formData.append('step_title', stepTitle);
  formData.append('file_name', fileName);
  formData.append('file', file);

  return this.http.post(
    `disbursement_timeline/${disbursementId}/document`,
    formData
  );
}
}
